import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ApplicationService } from 'src/app/services/http/application.service';
import { DictionaryItem, DictionaryItemGuid } from 'src/app/models/shared/dictionaryItem.model';
import { UtilityService } from 'src/app/services/http/utility.service';

@Component({
  selector: 'app-utilities-create-edit',
  templateUrl: './utilities-create-edit.component.html',
  styleUrls: ['./utilities-create-edit.component.scss']
})
export class UtilitiesCreateEditComponent implements OnInit {
  public rumberOfRedirectUrl: number = 1;
  showShadow = false;
  @Input() animationState = 'out';
  @Output() parentComp = new EventEmitter();
  @ViewChild("f") f: any;

  public selectedUtility : any = {      
    id : undefined,
    name : '',      
    applications : [''],
    entraClientId: "",
    entraTenantId: "",
    isEntraEnabled: false
  };

  applications: DictionaryItemGuid[] = []; 
  utilities: DictionaryItem[] = [];
  connectWithApp: boolean = false;
  selectedNewAppValue: any = "";
  newDomain: string = "";

  constructor(private ref: ElementRef,
    private toastr: ToastrService, private utilityService: UtilityService, private applicationService: ApplicationService
  ) { }

  trackByFn(index :any, item :any) {   return index; }

  ngOnInit(): void {
    
  }  

  handleClick(event: any) {
    const isSliderClicked = event.target.closest('.slider');
    if (this.animationState === 'in')
      if (this.ref.nativeElement.contains(event.target) || event.target === this.ref.nativeElement) {
        if (!isSliderClicked) {
          this.changeState(2);
        }
      }
  }

  getAllAplications() {
    this.applicationService.getAllForOptions().subscribe(response => {
      if(response.status == 200) {
        this.applications = response.data;
      }
    });
  }

  getUtility(id : any){
    this.utilityService.getById(id).subscribe(response => {
      if (response.status === 200) {
        this.selectedUtility = {
          name : response.data.name,
          applications: response.data.applications,
          id : response.data.id,
          entraClientId: response.data.entraClientId,
          entraTenantId: response.data.entraTenantId,
          isEntraEnabled: response.data.isEntraEnabled
        };
      } else{
        this.toastr.error(response.message);
        this.changeState(2)
      }
    }, error => {
      this.toastr.error('An error occurred.');
      this.changeState(2)
    });
  }

  toggleShowDiv(divName: string) {
    if (divName === 'open') {
      this.animationState = 'in';
    } else if (divName === 'close')
      this.animationState = 'out';
  }

  changeState(number: Number, data?: any) {
    if (data) {
      this.getUtility(data.id);
    }
    else {
      this.selectedUtility = {
        applications : [''],
        name : '',
        id : undefined,
      };
      
    }
    if (number === 1) {
      this.toggleShowDiv("open");
      this.showShadow = true;

    }
    if (number === 2) {
      this.toggleShowDiv("close");
      this.showShadow = false;
      this.f.submitted = false;
    }
  }

  useMicrosoftLogin() {
    this.selectedUtility.isEntraEnabled = !this.selectedUtility.isEntraEnabled;
  }

  save() {
        this.utilityService.save(this.selectedUtility).subscribe(response => {
      if (response.status === 200) {
        this.toastr.success(response.message);
        this.parentComp.emit()
      } else
        this.toastr.error(response.message);
    }, error => {
      this.toastr.error('An error occurred.');
    });

    this.changeState(2)
  }  
  deleteApplication(index: number) {
    this.selectedUtility.applications.splice(index, 1);
  }

  addApp() {
    this.connectWithApp = true;
    this.getAllAplications();
  }

  saveApp() {
    if(this.selectedNewAppValue == '') {
      this.toastr.error('Please select an application');
      return;
    } 

    if(this.newDomain == '') {
      this.toastr.error('Please insert domain.');
      return;
    }
    let newUtilityApp = {
      applicationId: this.selectedNewAppValue,
      domain: this.newDomain,
      applicationName: this.applications.find(x => x.value == this.selectedNewAppValue)?.name
    }
    
    this.selectedUtility.applications.push(newUtilityApp);
    this.connectWithApp = false;
  }
}